module.exports = __webpack_public_path__ + "media/use_cases/slider-landscape-1-8a7c3ac9.png";